import React, { useState, useEffect } from "react";
import SearchInput from "./SearchInput";
import FilterButton from "./FilterButton";
import "./SearchAndFilter.scss";
import FilterPopover from "./FilterPopover";

const SearchAndFilter = ({
  // Search props
  searchValue = "",
  onSearchChange,
  searchPlaceholder = "Search...",

  // Filter props
  filterOptions = [],
  selectedFilters = {},
  onFilterChange,
  onClearAllFilters,

  // UI props
  showFilterModal,
  onShowFilterModal,
  filterButtonText = "Filter",

  // Translations
  translations = {
    clear: "Clear",
    apply: "Apply",
    notFound: "No options found",
  },

  // Layout props
  className = "",
  style = {},
  searchInputProps = {},
  filterButtonProps = {},
  filterPopoverProps = {},
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

  const open = Boolean(anchorEl);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleFilterClick = (event) => {
    if (isSmallScreen || window.innerWidth <= 1024) {
      if (onShowFilterModal) {
        onShowFilterModal(true);
      }
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
  };

  const getActiveFiltersCount = () => {
    return Object.values(selectedFilters).reduce(
      (sum, arr) => sum + (Array.isArray(arr) ? arr.length : 0),
      0
    );
  };

  const handleClearAllFilters = () => {
    if (onClearAllFilters) {
      onClearAllFilters();
    }
  };

  return (
    <div className={`search-and-filter-container ${className}`} style={style}>
      <div className="filters-panel">
        <div className="search-box">
          <SearchInput
            value={searchValue}
            onChange={onSearchChange}
            placeholder={searchPlaceholder}
            {...searchInputProps}
          />
        </div>

        <FilterButton
          onClick={handleFilterClick}
          activeFiltersCount={getActiveFiltersCount()}
          {...filterButtonProps}
        >
          {filterButtonText}
        </FilterButton>
      </div>

      <FilterPopover
        open={open}
        anchorEl={anchorEl}
        onClose={handleFilterClose}
        filterOptions={filterOptions}
        selectedFilters={selectedFilters}
        onFilterChange={onFilterChange}
        onClearAll={handleClearAllFilters}
        isSmallScreen={isSmallScreen}
        translations={translations}
        {...filterPopoverProps}
      />
    </div>
  );
};

export default SearchAndFilter;
